import { render } from "./TextAndIconSection.vue?vue&type=template&id=7ade478a"
import script from "./TextAndIconSection.vue?vue&type=script&lang=js"
export * from "./TextAndIconSection.vue?vue&type=script&lang=js"

import "./TextAndIconSection.vue?vue&type=style&index=0&id=7ade478a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__